import React from "react";

import { Button } from "react-bootstrap";
import {
  ApproveIcon,
  CancelIcon,
  UnApproveIcon,
  SampleRollIcon
} from "../gui_components/Icons.js";
import { CopyPlus, FileOutput, Receipt, Mail } from "lucide-react";

export class SalesOrderModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowApproveButton: this.props.isShowApproveButton,
      isShowCancelButton: this.props.isShowCancelButton,
    };
  }
  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  copySO = (e) => {
    if (e.detail === 1) this.props.copySO();
  };

  changeCustomer = (e) => {
    if (e.detail === 1) this.props.changeCustomer();
  };
  approveSalesOrder = (e) => {
    if (e.detail === 1) this.props.approveSalesOrder();
  };

  generatePickTicket = (e) => {
    if (e.detail === 1) this.props.generatePickTicket();
  };

  generatePickTicketAdv = (e) => {
    if (e.detail === 1) this.props.generatePickTicketAdv();
  };

  generatePO = (e) => {
    if (e.detail === 1) this.props.generatePO();
  };

  proformaInvoice = (e) => {
    if (e.detail === 1) this.props.proformaInvoice();
  };

  cancelSalesOrder = (e) => {
    if (e.detail === 1) this.props.cancelSalesOrder();
  };
  createMail = (e) => {
    if (e.detail === 1) this.props.createMail();
  };
  unApproveSalesOrder = (e) => {
    if (e.detail === 1) this.props.unApproveSalesOrder();
  };
  specialApproveSalesOrder = (e) => {
    if (e.detail === 1) this.props.specialApproveSalesOrder();
  };
    addSampleRoll = (e) => {
    if (e.detail === 1) this.props.addSampleRoll();
  };
  render() {
    return (
      <>
        {this.props.isShowChangeCustomerButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.changeCustomer(e)}
          >
            <CopyPlus size={16} />
            Change Customer
          </Button>
        )}
        {this.props.isShowCopySOButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.copySO(e)}
          >
            <CopyPlus size={16} />
            Copy SO
          </Button>
        )}
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approveSalesOrder(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}

        {this.props.isShowGeneratePickTicketButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generatePickTicket(e)}
          >
            <ApproveIcon />
            PickTicket
          </Button>
        )}
        {this.props.isShowGeneratePickTicketAdvButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generatePickTicketAdv(e)}
          >
            <ApproveIcon />
            PickTicket ADV
          </Button>
        )}

        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelSalesOrder(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}
        {this.props.isShowGeneratePOButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generatePO(e)}
          >
            <FileOutput size={16} />
            Generate PO
          </Button>
        )}
        {this.props.isShowProformaInvButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.proformaInvoice(e)}
          >
            <Receipt size={16} />
            Proforma Invoice
          </Button>
        )}
        {this.props.isShowMailButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.createMail(e)}
          >
            <Mail size={16} />
            Mail
          </Button>
        )}
        {this.props.isShowUnApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.unApproveSalesOrder(e)}
          >
            <UnApproveIcon />
            UnApprove
          </Button>
        )}

        {this.props.isShowSpecialApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.specialApproveSalesOrder(e)}
          >
            <ApproveIcon />
            Special Approve
          </Button>
        )}

          {this.props.isShowAddSampleRollButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.addSampleRoll(e)}
          >
            <SampleRollIcon />
            Sample Roll
          </Button>
        )}
      </>


      
    );
  }
}
